export enum WizardStepEnum {
    Welcome,
    Common,
    Finished
}

export enum NextState {
    Idle,
    Processing,
    Done
}

export type Dictionary<T = string> = {
    [key: string]: T;
};

export type WizardStepWelcome = {
    name: string;
    description: string;
    next_button?: string;
    type: WizardStepEnum.Welcome;
    logId?: string;
};

export type WizardStepCommon = {
    name: string;
    nameShort?: string;
    next_button?: string;
    component: React.FC;
    customNextText?: string;
    type: WizardStepEnum.Common | WizardStepEnum.Finished;
    hideStep?: boolean;
    logId?: string;
};

export type Stage = {
    name: string;
    steps: (WizardStepWelcome | WizardStepCommon)[];
};
